import React from "react";
import PropTypes from "prop-types";
import { TextField } from "@mui/material";
import { useField, useFormikContext, ErrorMessage } from "formik";
import FormikLabel from "./FormikLabel";

import { ErrorStyle } from "./ErrorStyle";

const FormikTextarea = ({
  name = "",
  label = "",
  width = "100%",
  required = false,
  placeholder = "",
  rows = 4,
  disabled = false,
  readOnly = false,
  inputRestriction = "alphabetic", // Default restriction to allow only letters
  onChange = () => { }, // Default onChange function
  ...props
}) => {
  const [field] = useField(name);
  const { setFieldValue } = useFormikContext();

  const handleChange = (event) => {
    let { value } = event.target;

    // Strip HTML/script tags
    value = value.replace(/<[^>]*>/g, "");

    // Apply input restriction based on prop 
    if (inputRestriction === "alphanumeric") {
      value = value.replace(/[^a-zA-Z0-9\s]/g, ""); // Allow letters, numbers, and spaces
    } else if (inputRestriction === "numeric") {
      value = value.replace(/[^0-9]/g, ""); // Allow only numbers
    } else if (inputRestriction === "all") {
      // Allow everything — no restriction
      value = value;
    } else {
      value = value.replace(/[^a-zA-Z\s]/g, ""); // Default: Allow only letters and spaces
    }


    setFieldValue(name, value);

    // Call the provided onChange function with the updated value
    onChange({
      ...event,
      target: { ...event.target, value },
    });
  };

  return (
    <div style={{ width }}>
      <FormikLabel text={label} required={required} />
      <TextField
        {...field}
        {...props}
        placeholder={placeholder}
        multiline
        rows={rows}
        fullWidth
        disabled={disabled}
        inputProps={{
          readOnly: readOnly,
        }}
        onChange={(e) => {
          if (!readOnly) {
            handleChange(e);
          }
        }}
        sx={{
          ...props.sx,
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            borderWidth: "1px",
            backgroundColor: disabled || readOnly ? "#f5f5f5" : "inherit",
          },
        }}
      />
      <div style={ErrorStyle}>
        <ErrorMessage name={name} />
      </div>
    </div>
  );
};

FormikTextarea.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  width: PropTypes.string,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  rows: PropTypes.number,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  inputRestriction: PropTypes.oneOf(["alphabetic", "alphanumeric", "numeric"]),
  onChange: PropTypes.func,
};

export default FormikTextarea;
